import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Card, CardTitle, Label, FormGroup, Button } from "reactstrap";
import axios from "axiosClient";
import { Formik, Form, Field } from "formik";

import { Colxx } from "../components/common/CustomBootstrap";
import UserLayout from "layout/UserLayout";
import { useToken } from "auth/useToken";

const Login = ({ loading }) => {
  const navigate = useNavigate();
  const [token, setToken] = useToken();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({
    username: "",
    password: "",
    server: "",
  });

  const onUserLogin = async (e) => {
    e.preventDefault();
    if (!loading) {
      if (password === "") {
        setErrors({ ...errors, password: "Please enter your password" });
      } else if (username === "") {
        setErrors({ ...errors, username: "Please enter your login" });
      } else if (password.length < 6) {
        setErrors({
          ...errors,
          password: "Value must be at least 6 characters",
        });
      } else if (username !== "" && password !== "") {
        try {
          const response = await axios.post("/api/partner-login", {
            username,
            password,
          });
          setToken(response.data);
          navigate("/home");
        } catch (error) {
          // console.log(error.response);
          setErrors({ ...errors, server: error?.response?.data });
        }
      }
    }
  };

  return (
    <UserLayout>
      <Row className="h-100">
        <Colxx xxs="12" md="10" className="mx-auto my-auto">
          <Card className="auth-card">
            <div className="position-relative image-side ">
              <p className="text-white h2">IELTS Partners</p>
              <p className="white mb-0">
                Please use your credentials to login.
              </p>
            </div>
            <div className="form-side">
              <CardTitle className="mb-4">Login</CardTitle>
              <Formik>
                {() => (
                  <Form
                    className="av-tooltip tooltip-label-bottom"
                    onSubmit={onUserLogin}
                  >
                    <FormGroup className="form-group has-float-label">
                      <Label>Login</Label>
                      <Field
                        className="form-control"
                        name="username"
                        placeholder="login"
                        value={username}
                        onChange={(e) => {
                          setUsername(e.target.value);
                          setErrors({ ...errors, server: "", username: "" });
                        }}
                      />
                      {errors.username !== "" && (
                        <div className="invalid-feedback d-block">
                          {errors.username}
                        </div>
                      )}
                    </FormGroup>
                    <FormGroup className="form-group has-float-label">
                      <Label>Password</Label>
                      <Field
                        className="form-control"
                        type="password"
                        name="password"
                        value={password}
                        onChange={(e) => {
                          setPassword(e.target.value);
                          setErrors({ ...errors, server: "", password: "" });
                        }}
                      />
                      {errors.password !== "" && (
                        <div className="invalid-feedback d-block">
                          {errors.password}
                        </div>
                      )}
                    </FormGroup>
                    <div className="d-flex justify-content-between align-items-center">
                      <p>&nbsp;</p>
                      <p>{errors.server}</p>
                      <Button
                        type="submit"
                        color="primary"
                        className={`btn-shadow btn-multiple-state ${
                          loading ? "show-spinner" : ""
                        }`}
                        size="lg"
                      >
                        <span className="spinner d-inline-block">
                          <span className="bounce1" />
                          <span className="bounce2" />
                          <span className="bounce3" />
                        </span>
                        <span className="label">Login</span>
                      </Button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </Card>
        </Colxx>
      </Row>
    </UserLayout>
  );
};

export default Login;
